const translations = {
  en: {
    nav: {
      home: "Home", products: "Products", about: "About Us",
      dealers: "Dealer Network", gallery: "Gallery", contact: "Contact Us", cta: "Get a Quote",
    },
    hero: {
      badge: "Punjab's #1 Agriculture Machinery Brand",
      tagline: "Modern Machines,", tagline2: "Prosperous Farmers",
      subtitle: "Trusted by thousands of farmers across Punjab. Quality agriculture machinery, manufactured in India.",
      ctaFarmer: "Buy Direct — Punjab Prices", ctaDealer: "Become a Dealer",
      scrollHint: "Scroll to explore",
    },
    products: {
      sectionBadge: "Our Products",
      title: "Built for Indian Fields.", title2: "Built to Last.",
      subtitle: "Each machine engineered to match Indian soil conditions and farmer needs.",
      learnMore: "View Details", enquire: "Enquire Now",
      items: [
        {
          id: "rotavator", name: "Rotavator", tagline: "Superior Soil Preparation",
          description: "3 model ranges — Regular, Max Pro & Max Pro Plus. Built with High Tensile EN Steel blades (L/C/Hammer type), Floating Gearbox and EN 353 Side Gears. Engineered for both dry and wet soil across all Indian farming conditions.",
          specs: ["Power: 30–60 HP", "Width: 3–10 ft", "Blades: 30–72 (L/C/Hammer)", "RPM: 540/720/1000"],
          color: "from-forest-900 to-forest-500",
          image: "https://static.prod-images.emergentagent.com/jobs/2a6bfe0d-bf62-4b21-995b-6c2794398f74/images/2736588ffe164191fa9c880572a8e28ea9c07d69de042ce86778f551f3941c47.png",
        },
        {
          id: "disk-harrow", name: "Disk Harrow", tagline: "Deep Soil Breaking",
          description: "Heavy-duty disk harrow for breaking hard soil clods and preparing a fine seedbed. Suitable for all soil types across India.",
          specs: ["Disc Dia: 18–24 inch", "Spacing: 8–9 inch", "Discs: 12–28", "Frame: Heavy MS"],
          color: "from-amber-900 to-amber-700",
          image: "https://static.prod-images.emergentagent.com/jobs/2a6bfe0d-bf62-4b21-995b-6c2794398f74/images/cef886afc06451331fc06e00736d25a8fd8fe7251907f3dca5bcb9db9b1b4fa0.png",
        },
        {
          id: "mulcher", name: "Mulcher", tagline: "Crop Residue Management",
          description: "Efficiently shreds and mixes crop residue into the soil. Eliminates stubble burning and enriches soil fertility naturally.",
          specs: ["Power: 50–90 HP", "Width: 6–8 ft", "Blade: Y-Type", "540 RPM PTO"],
          color: "from-green-900 to-green-700",
          image: "https://static.prod-images.emergentagent.com/jobs/2a6bfe0d-bf62-4b21-995b-6c2794398f74/images/eabde4b31381dc6322f20cd7057a83fe24041160a11f2f504ff3ed0f0e6d5184.png",
        },
        {
          id: "fertilizer-spreader", name: "Fertilizer Spreader", tagline: "Precise Fertilizer Application",
          description: "Centrifugal broadcast spreader for even distribution of fertilizer, seeds and lime. Reduces input cost and maximizes crop yield with uniform coverage.",
          specs: ["Power: 30–50 HP", "Hopper: 100–300 L", "Spread Width: 6–12 m", "540 RPM PTO"],
          color: "from-orange-900 to-orange-700",
          image: "https://static.prod-images.emergentagent.com/jobs/2a6bfe0d-bf62-4b21-995b-6c2794398f74/images/30d829a4a048519cd09773e6034619082be6a3b25a573a2212c2e3ac8be07f6f.png",
        },
        {
          id: "potato-mulcher", name: "Haloom Mulcher (Potato Mulcher)", tagline: "Potato Crop Management",
          description: "Potato Haulm Cutter for efficient shredding of potato vines before harvest. 3-row design clears fields fast, improves harvesting speed and reduces manual labour significantly.",
          specs: ["Power: 40+ HP", "Rows: 3 (Adjustable 24\"–30\")", "Weight: ~710 kg", "Width: ~2156 mm"],
          color: "from-yellow-900 to-yellow-700",
          image: "https://static.prod-images.emergentagent.com/jobs/204fd1ee-d5f5-41fd-b62b-c3d59da90620/images/79755e38c98e28a5fbc8453738bc5150565dc6ea5fea24579f13498803ae7691.png",
        },
        {
          id: "cultivator", name: "Spring Tine Cultivator", tagline: "Flexible Spring Steel Tillage",
          description: "ARV Spring Tine Cultivator with S-shaped boron steel spring tines. Tines flex and vibrate automatically over rocks and hard clods — zero breakage. Perfect for secondary tillage, weed control and seedbed preparation across all Indian soil types.",
          specs: ["Power: 35–65 HP", "Tines: 9–13 Spring", "Depth: 10–20 cm", "3-Point Hitch"],
          color: "from-green-900 to-green-700",
          image: "https://static.prod-images.emergentagent.com/jobs/e89b0584-7119-4b81-8776-d969682d4e3f/images/4c5c0dde1d9b93f74b0fb8abc1e764130cebabc0bfb040f3ad2fda59de9ee7b3.png",
        },
        {
          id: "mini-rotavator", name: "Mini Rotavator", tagline: "Compact Tillage for Small Farms",
          description: "Specially designed ARV Mini Rotavator for small and medium farms, orchards and hilly terrain. Same EN Steel blade quality as our full-size rotavators — compact, lightweight, works with 20–35 HP tractors.",
          specs: ["Power: 20–35 HP", "Width: 3–5 ft", "Blades: 16–30 (L-Type)", "RPM: 540/720"],
          color: "from-orange-900 to-orange-700",
          image: "https://static.prod-images.emergentagent.com/jobs/e89b0584-7119-4b81-8776-d969682d4e3f/images/db1b02de5fc0f01599b62ff23dfc5039d4eaf40081339965f2d08d144277c38e.png",
        },
      ]
    },
    farmers: {
      badge: "For Punjab Farmers",
      title: "Direct from Factory", title2: "to Your Farm",
      subtitle: "No middlemen. Pure savings. Pure trust.",
      description: "As we manufacture right here in Punjab, we offer direct-from-factory pricing to our local farming community. Get the best machinery at the best price — straight from us to your farm.",
      benefits: [
        "Factory Direct Pricing — No Dealer Markup",
        "On-Site Demo Before Purchase",
        "After-Sales Service at Your Village",
      ],
      cta: "Enquire for Direct Price",
    },
    dealers: {
      badge: "Pan India Dealer Program",
      title: "Partner with the Best.", title2: "Grow Together.",
      subtitle: "Join our growing dealer network. Become an authorized partner across India.",
      description: "Become an authorized dealer of Shree Ram Agro Industries and tap into India's booming agriculture machinery market. We provide full support — from training to marketing materials.",
      benefits: [
        "Exclusive Territory Rights",
        "High Profit Margins",
        "Marketing & Promotional Support",
        "Technical Training for Your Team",
        "Fast Delivery & Stock Support",
        "Strong Brand Recognition Across India",
      ],
      cta: "Apply for Dealership",
    },
    whyUs: {
      badge: "Why Choose Us",
      title: "The Shree Ram Agro Difference",
      items: [
        { icon: "Award", title: "Proven Quality", desc: "Every machine undergoes rigorous quality testing before leaving our factory gates." },
        { icon: "Users", title: "Farmer First", desc: "Products designed by engineers who understand the ground realities of Indian farming." },
        { icon: "Wrench", title: "After-Sales Service", desc: "Dedicated service network across Punjab with quick turnaround for repairs." },
        { icon: "TrendingUp", title: "Trusted by Farmers", desc: "Serving Indian farmers and dealers with consistent quality machinery built to last." },
        { icon: "Shield", title: "Warranty Assured", desc: "All products come with manufacturer warranty and genuine spare parts." },
        { icon: "MapPin", title: "Made in India", desc: "Proudly manufactured in Punjab — India's agricultural heartland." },
      ]
    },
    testimonials: {
      badge: "What They Say",
      title: "Trusted by Farmers & Dealers Across India",
      items: [
        { name: "Gurpreet Singh", location: "Ludhiana, Punjab", role: "Farmer", quote: "Been using their Rotavator for 5 seasons. The best investment I made for my 12-acre farm. Zero breakdowns!" },
        { name: "Balvinder Kaur", location: "Amritsar, Punjab", role: "Farmer", quote: "Shree Ram's Disk Harrow prepared our 20-acre field in record time. Strong build, zero issues even in hard clay soil. Highly recommended!" },
        { name: "Rajesh Verma", location: "Karnal, Haryana", role: "Dealer", quote: "Great margins, timely delivery, and amazing brand recognition. My best decision to become their dealer." },
      ]
    },
    ctaBanner: {
      title: "Ready to Transform Your Farm?",
      subtitle: "Talk to our agriculture experts today. Call, WhatsApp, or fill in a form.",
      btnFarmer: "Enquire as a Farmer",
      btnDealer: "Enquire as a Dealer",
    },
    about: {
      badge: "About Us",
      title: "Built in Punjab,", title2: "Trusted Across India",
      description: "Shree Ram Agro Industries was founded with a single vision: to empower Indian farmers with world-class, affordable agriculture machinery. Based in the heart of Punjab — India's food bowl — we understand the land, the crops, and the needs of every Indian farmer.",
      mission_title: "Our Mission",
      mission: "To manufacture the most reliable and affordable agricultural machinery that transforms Indian farming — one field at a time.",
      values: [
        { title: "Quality First", desc: "Every machine is tested rigorously before it leaves our factory." },
        { title: "Farmer Focused", desc: "All products designed with the Indian farmer's real needs in mind." },
        { title: "Innovation", desc: "Continuously improving our products with modern technology." },
        { title: "Trust", desc: "Our consistent quality has earned the trust of thousands of farmers across India." },
      ],
      journey: [
        { year: "2009", event: "Founded in Punjab with a small workshop and big dreams." },
        { year: "2012", event: "Launched first Rotavator model, sold 200 units in year one." },
        { year: "2015", event: "Expanded to Disk Harrow and Mulcher product lines." },
        { year: "2018", event: "Crossed 100 dealer partners across North India." },
        { year: "2021", event: "Launched Fertilizer Spreader and Potato Mulcher — expanding product range for North India." },
        { year: "2024", event: "Expanding product range and dealer network across India." },
      ],
      teamTitle: "Manufacturing Excellence",
      teamDesc: "Our modern manufacturing facility in Punjab uses precision laser cutting technology. With 40+ skilled workers, we build heavy-duty, reliable agricultural machinery built to withstand demanding field conditions.",
    },
    dealers_page: {
      hero_title: "Become a Dealer", hero_subtitle: "Join our growing dealer network across India",
      benefits_title: "Why Partner with Us?",
      process_title: "How to Become a Dealer",
      process: [
        { step: "01", title: "Submit Application", desc: "Fill out the dealer application form with your business details." },
        { step: "02", title: "Verification Call", desc: "Our team will call you within 48 hours to discuss the opportunity." },
        { step: "03", title: "Agreement & Training", desc: "Sign the dealership agreement and attend product training." },
        { step: "04", title: "Start Selling!", desc: "Receive your first stock and begin serving farmers in your territory." },
      ],
      form_title: "Apply for Dealership",
      form: {
        name: "Your Full Name", business: "Business / Shop Name",
        phone: "Phone Number", email: "Email Address",
        state: "Select State", city: "Your City",
        brands: "Existing Brands You Deal In (optional)", message: "Tell us about your business",
        submit: "Submit Application",
        success: "Application submitted! Our team will contact you within 48 hours.",
      }
    },
    contact: {
      title: "Contact Us", subtitle: "We're here to help. Reach out anytime.",
      form: {
        name: "Full Name", phone: "Phone Number", email: "Email (Optional)",
        product: "Product Interest", state: "Your State", message: "Your Message",
        submit: "Send Enquiry",
        success: "Thank you! We'll contact you within 24 hours.",
      },
      info: {
        address: "Phase-7, Focal Point, Near Ashoka Kanda, Village Gobindgarh, Ludhiana, Punjab — 141010",
        phone: "+91 76968 99983", email: "shreeramagroindustries2024@gmail.com",
        hours: "Mon–Sat: 9:00 AM – 6:00 PM",
        whatsapp: "Chat on WhatsApp",
      }
    },
    gallery: {
      badge: "Gallery", title: "Our Machines in Action",
      subtitle: "See how Shree Ram Agro machinery is transforming farms across India.",
      photos: "Photos", videos: "Videos",
    },
    footer: {
      tagline: "आधुनिक यंत्र, समृद्ध किसान | ਆਧੁਨਿਕ ਯੰਤਰ, ਖੁਸ਼ਹਾਲ ਕਿਸਾਨ",
      about: "Punjab's trusted manufacturer of quality agriculture machinery. Serving farmers and dealers across India.",
      quickLinks: "Quick Links", products: "Products", contactInfo: "Contact Info",
      copyright: "© 2024 Shree Ram Agro Industries. All Rights Reserved. | Made with pride in Punjab, India.",
      links: { products: "Our Products", about: "About Us", dealers: "Dealer Program", contact: "Contact Us", gallery: "Gallery" }
    }
  },

  hi: {
    nav: {
      home: "होम", products: "उत्पाद", about: "हमारे बारे में",
      dealers: "डीलर नेटवर्क", gallery: "गैलरी", contact: "संपर्क करें", cta: "कोटेशन लें",
    },
    hero: {
      badge: "पंजाब का नंबर 1 कृषि यंत्र ब्रांड",
      tagline: "आधुनिक यंत्र,", tagline2: "समृद्ध किसान",
      subtitle: "हजारों किसानों का विश्वास। भारत में निर्मित गुणवत्तापूर्ण कृषि यंत्र।",
      ctaFarmer: "सीधे खरीदें — पंजाब कीमत", ctaDealer: "डीलर बनें",
      scrollHint: "नीचे स्क्रॉल करें",
    },
    products: {
      sectionBadge: "हमारे उत्पाद",
      title: "भारतीय खेतों के लिए बने।", title2: "टिकाऊ और भरोसेमंद।",
      subtitle: "हर यंत्र भारतीय मिट्टी और किसान की जरूरत के हिसाब से बनाया गया है।",
      learnMore: "विवरण देखें", enquire: "अभी पूछताछ करें",
      items: [
        { id: "rotavator", name: "रोटावेटर", tagline: "बेहतरीन मिट्टी तैयारी",
          description: "3 मॉडल सीरीज — Regular, Max Pro और Max Pro Plus। High Tensile EN Steel ब्लेड, Floating Gearbox और EN 353 Side Gear के साथ। सूखी और गीली दोनों मिट्टी के लिए उपयुक्त।",
          specs: ["शक्ति: 30-60 HP", "चौड़ाई: 3-10 फीट", "ब्लेड: 30-72 (L/C/हैमर)", "RPM: 540/720/1000"],
          color: "from-forest-900 to-forest-500",
          image: "https://static.prod-images.emergentagent.com/jobs/2a6bfe0d-bf62-4b21-995b-6c2794398f74/images/2736588ffe164191fa9c880572a8e28ea9c07d69de042ce86778f551f3941c47.png",
        },
        { id: "disk-harrow", name: "डिस्क हैरो", tagline: "गहरी मिट्टी तोड़ना",
          description: "भारी मिट्टी के ढेलों को तोड़ने और अच्छा बीजतल तैयार करने के लिए मजबूत डिस्क हैरो।",
          specs: ["डिस्क: 18-24 इंच", "दूरी: 8-9 इंच", "संख्या: 12-28", "फ्रेम: हेवी MS"],
          color: "from-amber-900 to-amber-700",
          image: "https://static.prod-images.emergentagent.com/jobs/2a6bfe0d-bf62-4b21-995b-6c2794398f74/images/cef886afc06451331fc06e00736d25a8fd8fe7251907f3dca5bcb9db9b1b4fa0.png",
        },
        { id: "mulcher", name: "मल्चर", tagline: "फसल अवशेष प्रबंधन",
          description: "फसल अवशेषों को कुशलता से काटता है। पराली जलाने से मुक्ति और मिट्टी की उर्वरता में वृद्धि।",
          specs: ["शक्ति: 50-90 HP", "चौड़ाई: 6-8 फीट", "ब्लेड: Y-टाइप", "540 RPM PTO"],
          color: "from-green-900 to-green-700",
          image: "https://static.prod-images.emergentagent.com/jobs/2a6bfe0d-bf62-4b21-995b-6c2794398f74/images/eabde4b31381dc6322f20cd7057a83fe24041160a11f2f504ff3ed0f0e6d5184.png",
        },
        { id: "fertilizer-spreader", name: "फर्टिलाइजर स्प्रेडर", tagline: "सटीक उर्वरक छिड़काव",
          description: "खाद, बीज और चूने का एकसमान प्रसार। फसल उत्पादन बढ़ाएं और इनपुट लागत कम करें।",
          specs: ["शक्ति: 30-50 HP", "हॉपर: 100-300 L", "फैलाव: 6-12 मीटर", "540 RPM PTO"],
          color: "from-orange-900 to-orange-700",
          image: "https://static.prod-images.emergentagent.com/jobs/2a6bfe0d-bf62-4b21-995b-6c2794398f74/images/30d829a4a048519cd09773e6034619082be6a3b25a573a2212c2e3ac8be07f6f.png",
        },
        { id: "potato-mulcher", name: "हालूम मल्चर (आलू मल्चर)", tagline: "आलू फसल प्रबंधन",
          description: "आलू की बेलें काटने वाली 3-कतार मशीन। फसल से पहले हॉम कटिंग — तेज़ कटाई, कम मेहनत।",
          specs: ["शक्ति: 40+ HP", "कतारें: 3 (समायोज्य 24\"-30\")", "वजन: ~710 kg", "चौड़ाई: ~2156 mm"],
          color: "from-yellow-900 to-yellow-700",
          image: "https://static.prod-images.emergentagent.com/jobs/204fd1ee-d5f5-41fd-b62b-c3d59da90620/images/79755e38c98e28a5fbc8453738bc5150565dc6ea5fea24579f13498803ae7691.png",
        },
        { id: "cultivator", name: "स्प्रिंग टाइन कल्टीवेटर", tagline: "लचीली स्प्रिंग इस्पात जुताई",
          description: "ARV स्प्रिंग टाइन कल्टीवेटर S-आकार के बोरॉन स्टील स्प्रिंग टाइन्स के साथ। टाइन्स पत्थरों पर अपने आप मुड़ जाते हैं — जीरो ब्रेकेज। द्वितीयक जुताई, खरपतवार नियंत्रण और बीजशय्या तैयारी।",
          specs: ["शक्ति: 35-65 HP", "टाइन्स: 9-13 स्प्रिंग", "गहराई: 10-20 सेमी", "3-पॉइंट हिच"],
          color: "from-green-900 to-green-700",
          image: "https://static.prod-images.emergentagent.com/jobs/e89b0584-7119-4b81-8776-d969682d4e3f/images/4c5c0dde1d9b93f74b0fb8abc1e764130cebabc0bfb040f3ad2fda59de9ee7b3.png",
        },
        { id: "mini-rotavator", name: "मिनी रोटावेटर", tagline: "छोटे खेतों के लिए कॉम्पैक्ट जुताई",
          description: "ARV मिनी रोटावेटर छोटे और मध्यम खेतों, बागों और पहाड़ी इलाकों के लिए विशेष रूप से बनाया गया। EN Steel ब्लेड, 20-35 HP ट्रैक्टर के साथ संगत।",
          specs: ["शक्ति: 20-35 HP", "चौड़ाई: 3-5 फीट", "ब्लेड: 16-30 (L-टाइप)", "RPM: 540/720"],
          color: "from-orange-900 to-orange-700",
          image: "https://static.prod-images.emergentagent.com/jobs/e89b0584-7119-4b81-8776-d969682d4e3f/images/db1b02de5fc0f01599b62ff23dfc5039d4eaf40081339965f2d08d144277c38e.png",
        },
      ]
    },
    farmers: {
      badge: "पंजाब किसानों के लिए",
      title: "फैक्टरी से सीधे", title2: "आपके खेत तक",
      subtitle: "कोई बिचौलिया नहीं। शुद्ध बचत। शुद्ध विश्वास।",
      description: "पंजाब में निर्माण होने से, हम स्थानीय किसानों को सीधे कीमतें देते हैं। बेहतरीन मशीनरी, बेहतरीन कीमत पर।",
      benefits: [
        "फैक्टरी डायरेक्ट प्राइस — कोई डीलर मार्कअप नहीं",
        "खरीदने से पहले साइट पर डेमो",
        "आपके गांव में आफ्टर-सेल्स सर्विस",
      ],
      cta: "सीधी कीमत के लिए पूछें",
    },
    dealers: {
      badge: "पैन इंडिया डीलर प्रोग्राम",
      title: "सर्वश्रेष्ठ के साथ भागीदारी।", title2: "साथ बढ़ें।",
      subtitle: "पूरे भारत में हमारे बढ़ते डीलर नेटवर्क से जुड़ें।",
      description: "श्री राम एग्रो इंडस्ट्रीज के अधिकृत डीलर बनें और बढ़ते कृषि यंत्र बाजार का लाभ उठाएं।",
      benefits: [
        "एक्सक्लूसिव टेरिटरी अधिकार",
        "उच्च लाभ मार्जिन",
        "मार्केटिंग और प्रमोशनल सहायता",
        "आपकी टीम के लिए तकनीकी प्रशिक्षण",
        "तेज डिलीवरी और स्टॉक सपोर्ट",
        "पूरे भारत में मजबूत ब्रांड पहचान",
      ],
      cta: "डीलरशिप के लिए आवेदन करें",
    },
    whyUs: {
      badge: "हमें क्यों चुनें",
      title: "श्री राम एग्रो का अंतर",
      items: [
        { icon: "Award", title: "सिद्ध गुणवत्ता", desc: "हर मशीन फैक्टरी से निकलने से पहले कड़े परीक्षण से गुजरती है।" },
        { icon: "Users", title: "किसान पहले", desc: "उत्पाद उन इंजीनियरों द्वारा डिज़ाइन किए गए जो भारतीय खेती को समझते हैं।" },
        { icon: "Wrench", title: "आफ्टर-सेल्स सेवा", desc: "पंजाब भर में डेडिकेटेड सर्विस नेटवर्क।" },
        { icon: "TrendingUp", title: "किसानों का विश्वास", desc: "लगातार गुणवत्तापूर्ण मशीनरी से हजारों किसानों और डीलरों का विश्वास अर्जित किया।" },
        { icon: "Shield", title: "वारंटी के साथ", desc: "सभी उत्पादों पर निर्माता वारंटी और असली स्पेयर पार्ट्स।" },
        { icon: "MapPin", title: "भारत में निर्मित", desc: "पंजाब में गर्व से निर्मित — भारत की कृषि भूमि।" },
      ]
    },
    testimonials: {
      badge: "वे क्या कहते हैं",
      title: "भारत भर के किसानों और डीलरों का विश्वास",
      items: [
        { name: "गुरप्रीत सिंह", location: "लुधियाना, पंजाब", role: "किसान", quote: "5 सीजन से उनका रोटावेटर उपयोग कर रहा हूं। 12 एकड़ के लिए सबसे अच्छा निवेश। कोई खराबी नहीं!" },
        { name: "बलविंदर कौर", location: "अमृतसर, पंजाब", role: "किसान", quote: "श्री राम के डिस्क हैरो से हमारे 20 एकड़ के खेत रिकॉर्ड समय में तैयार हो गए। मजबूत बनावट, कड़ी मिट्टी में भी कोई समस्या नहीं। शानदार मशीन!" },
        { name: "राजेश वर्मा", location: "करनाल, हरियाणा", role: "डीलर", quote: "बढ़िया मार्जिन, समय पर डिलीवरी और शानदार ब्रांड। उनका डीलर बनना मेरा सबसे अच्छा फैसला था।" },
      ]
    },
    ctaBanner: {
      title: "अपने खेत को बदलने के लिए तैयार हैं?",
      subtitle: "आज हमारे कृषि विशेषज्ञों से बात करें।",
      btnFarmer: "किसान के रूप में पूछताछ", btnDealer: "डीलर के रूप में पूछताछ",
    },
    about: {
      badge: "हमारे बारे में",
      title: "पंजाब में निर्मित,", title2: "पूरे भारत में विश्वसनीय",
      description: "श्री राम एग्रो इंडस्ट्रीज की स्थापना एक उद्देश्य से हुई: भारतीय किसानों को विश्वस्तरीय, किफायती कृषि यंत्र प्रदान करना। पंजाब — भारत के अन्न भंडार — में स्थित, हम हर भारतीय किसान की जरूरतों को समझते हैं।",
      mission_title: "हमारा मिशन",
      mission: "सबसे विश्वसनीय और किफायती कृषि यंत्र बनाना जो भारतीय खेती को बदले।",
      values: [
        { title: "गुणवत्ता पहले", desc: "हर मशीन फैक्टरी से निकलने से पहले कठोर परीक्षण।" },
        { title: "किसान केंद्रित", desc: "सभी उत्पाद भारतीय किसान की जरूरतों को ध्यान में रखकर।" },
        { title: "नवाचार", desc: "आधुनिक तकनीक से उत्पादों में निरंतर सुधार।" },
        { title: "विश्वास", desc: "हमारी निरंतर गुणवत्ता ने पूरे भारत में हजारों किसानों का विश्वास अर्जित किया है।" },
      ],
      journey: [
        { year: "2009", event: "पंजाब में एक छोटी कार्यशाला और बड़े सपनों के साथ स्थापना।" },
        { year: "2012", event: "पहला रोटावेटर मॉडल लॉन्च, पहले साल में 200 यूनिट बिके।" },
        { year: "2015", event: "डिस्क हैरो और मल्चर उत्पाद लाइन में विस्तार।" },
        { year: "2018", event: "उत्तर भारत में 100 डीलर पार्टनर।" },
        { year: "2021", event: "आधुनिक खेती के लिए लेजर लैंड लेवलर लॉन्च।" },
        { year: "2024", event: "पूरे भारत में उत्पाद श्रेणी और डीलर नेटवर्क का विस्तार।" },
      ],
      teamTitle: "विनिर्माण उत्कृष्टता",
      teamDesc: "पंजाब में हमारी आधुनिक निर्माण सुविधा में अत्याधुनिक लेजर कटिंग तकनीक का उपयोग होता है। 40+ कुशल कर्मचारियों के साथ, हम मजबूत और विश्वसनीय कृषि यंत्र बनाते हैं।",
    },
    dealers_page: {
      hero_title: "डीलर बनें", hero_subtitle: "भारत भर में हमारे बढ़ते डीलर नेटवर्क से जुड़ें",
      benefits_title: "हमारे साथ भागीदारी क्यों?",
      process_title: "डीलर कैसे बनें",
      process: [
        { step: "01", title: "आवेदन जमा करें", desc: "अपने व्यवसाय विवरण के साथ डीलर आवेदन फॉर्म भरें।" },
        { step: "02", title: "सत्यापन कॉल", desc: "हमारी टीम 48 घंटों के भीतर आपसे संपर्क करेगी।" },
        { step: "03", title: "समझौता और प्रशिक्षण", desc: "डीलरशिप समझौते पर हस्ताक्षर करें और उत्पाद प्रशिक्षण लें।" },
        { step: "04", title: "बिक्री शुरू करें!", desc: "पहला स्टॉक प्राप्त करें और अपने क्षेत्र में सेवा शुरू करें।" },
      ],
      form_title: "डीलरशिप के लिए आवेदन करें",
      form: {
        name: "आपका पूरा नाम", business: "व्यवसाय / दुकान का नाम",
        phone: "फोन नंबर", email: "ईमेल पता",
        state: "राज्य चुनें", city: "आपका शहर",
        brands: "मौजूदा ब्रांड (वैकल्पिक)", message: "अपने व्यवसाय के बारे में बताएं",
        submit: "आवेदन जमा करें",
        success: "आवेदन जमा हुआ! हमारी टीम 48 घंटों में संपर्क करेगी।",
      }
    },
    contact: {
      title: "संपर्क करें", subtitle: "हम मदद के लिए यहाँ हैं। कभी भी संपर्क करें।",
      form: {
        name: "पूरा नाम", phone: "फोन नंबर", email: "ईमेल (वैकल्पिक)",
        product: "उत्पाद रुचि", state: "आपका राज्य", message: "आपका संदेश",
        submit: "पूछताछ भेजें",
        success: "धन्यवाद! हम 24 घंटे में संपर्क करेंगे।",
      },
      info: {
        address: "फेज-7, फोकल पॉइंट, अशोका कांडा के पास, विलेज-गोबिंदगढ़, लुधियाना, पंजाब — 141010",
        phone: "+91 76968 99983", email: "shreeramagroindustries2024@gmail.com",
        hours: "सोम–शनि: सुबह 9 बजे – शाम 6 बजे",
        whatsapp: "WhatsApp पर चैट करें",
      }
    },
    gallery: {
      badge: "गैलरी", title: "हमारी मशीनें काम में",
      subtitle: "देखें कैसे श्री राम एग्रो मशीनरी पूरे भारत के खेतों को बदल रही है।",
      photos: "फोटो", videos: "वीडियो",
    },
    footer: {
      tagline: "आधुनिक यंत्र, समृद्ध किसान | ਆਧੁਨਿਕ ਯੰਤਰ, ਖੁਸ਼ਹਾਲ ਕਿਸਾਨ",
      about: "पंजाब का भरोसेमंद कृषि यंत्र निर्माता। पूरे भारत के किसानों और डीलरों की सेवा में।",
      quickLinks: "त्वरित लिंक", products: "उत्पाद", contactInfo: "संपर्क जानकारी",
      copyright: "© 2024 श्री राम एग्रो इंडस्ट्रीज। सर्वाधिकार सुरक्षित।",
      links: { products: "हमारे उत्पाद", about: "हमारे बारे में", dealers: "डीलर प्रोग्राम", contact: "संपर्क करें", gallery: "गैलरी" }
    }
  },

  pa: {
    nav: {
      home: "ਹੋਮ", products: "ਉਤਪਾਦ", about: "ਸਾਡੇ ਬਾਰੇ",
      dealers: "ਡੀਲਰ ਨੈੱਟਵਰਕ", gallery: "ਗੈਲਰੀ", contact: "ਸੰਪਰਕ ਕਰੋ", cta: "ਕੋਟੇਸ਼ਨ ਲਓ",
    },
    hero: {
      badge: "ਪੰਜਾਬ ਦਾ ਨੰਬਰ 1 ਖੇਤੀ ਮਸ਼ੀਨਰੀ ਬ੍ਰਾਂਡ",
      tagline: "ਆਧੁਨਿਕ ਯੰਤਰ,", tagline2: "ਖੁਸ਼ਹਾਲ ਕਿਸਾਨ",
      subtitle: "ਹਜ਼ਾਰਾਂ ਕਿਸਾਨਾਂ ਦਾ ਭਰੋਸਾ। ਭਾਰਤ ਵਿੱਚ ਬਣੀ ਵਧੀਆ ਖੇਤੀ ਮਸ਼ੀਨਰੀ।",
      ctaFarmer: "ਸਿੱਧਾ ਖਰੀਦੋ — ਪੰਜਾਬ ਕੀਮਤ", ctaDealer: "ਡੀਲਰ ਬਣੋ",
      scrollHint: "ਹੇਠਾਂ ਸਕ੍ਰੋਲ ਕਰੋ",
    },
    products: {
      sectionBadge: "ਸਾਡੇ ਉਤਪਾਦ",
      title: "ਭਾਰਤੀ ਖੇਤਾਂ ਲਈ ਬਣੇ।", title2: "ਮਜ਼ਬੂਤ ਅਤੇ ਭਰੋਸੇਮੰਦ।",
      subtitle: "ਹਰ ਯੰਤਰ ਭਾਰਤੀ ਮਿੱਟੀ ਅਤੇ ਕਿਸਾਨ ਦੀ ਲੋੜ ਅਨੁਸਾਰ ਬਣਾਇਆ ਗਿਆ ਹੈ।",
      learnMore: "ਵੇਰਵਾ ਦੇਖੋ", enquire: "ਹੁਣ ਪੁੱਛੋ",
      items: [
        { id: "rotavator", name: "ਰੋਟਾਵੇਟਰ", tagline: "ਵਧੀਆ ਮਿੱਟੀ ਤਿਆਰੀ",
          description: "3 ਮਾਡਲ ਸੀਰੀਜ਼ — Regular, Max Pro ਅਤੇ Max Pro Plus। High Tensile EN Steel ਬਲੇਡ, Floating Gearbox ਅਤੇ EN 353 Side Gear ਨਾਲ। ਸੁੱਕੀ ਅਤੇ ਗਿੱਲੀ ਦੋਵੇਂ ਮਿੱਟੀ ਲਈ ਯੋਗ।",
          specs: ["ਸ਼ਕਤੀ: 30-60 HP", "ਚੌੜਾਈ: 3-10 ਫੁੱਟ", "ਬਲੇਡ: 30-72 (L/C/ਹੈਮਰ)", "RPM: 540/720/1000"],
          color: "from-forest-900 to-forest-500",
          image: "https://static.prod-images.emergentagent.com/jobs/2a6bfe0d-bf62-4b21-995b-6c2794398f74/images/2736588ffe164191fa9c880572a8e28ea9c07d69de042ce86778f551f3941c47.png",
        },
        { id: "disk-harrow", name: "ਡਿਸਕ ਹੈਰੋ", tagline: "ਡੂੰਘੀ ਮਿੱਟੀ ਤੋੜਨਾ",
          description: "ਭਾਰੀ ਮਿੱਟੀ ਦੇ ਢੇਲਿਆਂ ਨੂੰ ਤੋੜਨ ਅਤੇ ਚੰਗਾ ਬੀਜ-ਬੈੱਡ ਤਿਆਰ ਕਰਨ ਲਈ ਡਿਸਕ ਹੈਰੋ।",
          specs: ["ਡਿਸਕ: 18-24 ਇੰਚ", "ਦੂਰੀ: 8-9 ਇੰਚ", "ਗਿਣਤੀ: 12-28", "ਫ੍ਰੇਮ: ਭਾਰੀ MS"],
          color: "from-amber-900 to-amber-700",
          image: "https://static.prod-images.emergentagent.com/jobs/2a6bfe0d-bf62-4b21-995b-6c2794398f74/images/cef886afc06451331fc06e00736d25a8fd8fe7251907f3dca5bcb9db9b1b4fa0.png",
        },
        { id: "mulcher", name: "ਮਲਚਰ", tagline: "ਫਸਲ ਰਹਿੰਦ-ਖੂੰਹਦ ਪ੍ਰਬੰਧਨ",
          description: "ਫਸਲ ਦੀ ਰਹਿੰਦ-ਖੂੰਹਦ ਨੂੰ ਕੁਸ਼ਲਤਾ ਨਾਲ ਕੱਟਦਾ ਹੈ। ਪਰਾਲੀ ਸਾੜਨ ਤੋਂ ਮੁਕਤੀ।",
          specs: ["ਸ਼ਕਤੀ: 50-90 HP", "ਚੌੜਾਈ: 6-8 ਫੁੱਟ", "ਬਲੇਡ: Y-ਟਾਈਪ", "540 RPM PTO"],
          color: "from-green-900 to-green-700",
          image: "https://static.prod-images.emergentagent.com/jobs/2a6bfe0d-bf62-4b21-995b-6c2794398f74/images/eabde4b31381dc6322f20cd7057a83fe24041160a11f2f504ff3ed0f0e6d5184.png",
        },
        { id: "fertilizer-spreader", name: "ਫਰਟੀਲਾਈਜ਼ਰ ਸਪ੍ਰੈਡਰ", tagline: "ਸਟੀਕ ਖਾਦ ਛਿੜਕਾਅ",
          description: "ਖਾਦ, ਬੀਜ ਅਤੇ ਚੂਨੇ ਦਾ ਇਕਸਾਰ ਫੈਲਾਅ। ਫਸਲ ਉਤਪਾਦਨ ਵਧਾਓ ਅਤੇ ਖਰਚਾ ਘਟਾਓ।",
          specs: ["ਸ਼ਕਤੀ: 30-50 HP", "ਹੌਪਰ: 100-300 L", "ਫੈਲਾਅ: 6-12 ਮੀਟਰ", "540 RPM PTO"],
          color: "from-orange-900 to-orange-700",
          image: "https://static.prod-images.emergentagent.com/jobs/2a6bfe0d-bf62-4b21-995b-6c2794398f74/images/30d829a4a048519cd09773e6034619082be6a3b25a573a2212c2e3ac8be07f6f.png",
        },
        { id: "potato-mulcher", name: "ਹਾਮ ਮਲਚਰ (ਆਲੂ ਮਲਚਰ)", tagline: "ਆਲੂ ਫਸਲ ਪ੍ਰਬੰਧਨ",
          description: "ਆਲੂ ਦੀਆਂ ਵੇਲਾਂ ਕੱਟਣ ਵਾਲੀ 3-ਕਤਾਰ ਮਸ਼ੀਨ। ਵਾਢੀ ਤੋਂ ਪਹਿਲਾਂ ਹਾਮ ਕੱਟਿੰਗ — ਤੇਜ਼ ਵਾਢੀ, ਘੱਟ ਮਿਹਨਤ।",
          specs: ["ਸ਼ਕਤੀ: 40+ HP", "ਕਤਾਰਾਂ: 3 (ਅਡਜਸਟੇਬਲ 24\"-30\")", "ਭਾਰ: ~710 kg", "ਚੌੜਾਈ: ~2156 mm"],
          color: "from-yellow-900 to-yellow-700",
          image: "https://static.prod-images.emergentagent.com/jobs/204fd1ee-d5f5-41fd-b62b-c3d59da90620/images/79755e38c98e28a5fbc8453738bc5150565dc6ea5fea24579f13498803ae7691.png",
        },
        { id: "cultivator", name: "ਸਪ੍ਰਿੰਗ ਟਾਈਨ ਕਲਟੀਵੇਟਰ", tagline: "ਲਚੀਲੀ ਸਪ੍ਰਿੰਗ ਸਟੀਲ ਜੁਤਾਈ",
          description: "ARV ਸਪ੍ਰਿੰਗ ਟਾਈਨ ਕਲਟੀਵੇਟਰ S-ਆਕਾਰ ਦੇ ਬੋਰੋਨ ਸਟੀਲ ਸਪ੍ਰਿੰਗ ਟਾਈਨਾਂ ਨਾਲ। ਟਾਈਨਾਂ ਪੱਥਰਾਂ ਉੱਤੇ ਆਪਣੇ ਆਪ ਮੁੜਦੀਆਂ ਹਨ। ਦੂਜੀ ਜੁਤਾਈ, ਨਦੀਨ ਕੰਟਰੋਲ ਅਤੇ ਬੀਜ ਬਿਸਤਰਾ ਤਿਆਰੀ।",
          specs: ["ਸ਼ਕਤੀ: 35-65 HP", "ਟਾਈਨਾਂ: 9-13 ਸਪ੍ਰਿੰਗ", "ਡੂੰਘਾਈ: 10-20 ਸੈਮੀ", "3-ਪੁਆਇੰਟ ਹਿੱਚ"],
          color: "from-green-900 to-green-700",
          image: "https://static.prod-images.emergentagent.com/jobs/e89b0584-7119-4b81-8776-d969682d4e3f/images/4c5c0dde1d9b93f74b0fb8abc1e764130cebabc0bfb040f3ad2fda59de9ee7b3.png",
        },
        { id: "mini-rotavator", name: "ਮਿਨੀ ਰੋਟਾਵੇਟਰ", tagline: "ਛੋਟੇ ਖੇਤਾਂ ਲਈ ਕੰਪੈਕਟ ਜੁਤਾਈ",
          description: "ARV ਮਿਨੀ ਰੋਟਾਵੇਟਰ ਛੋਟੇ ਅਤੇ ਦਰਮਿਆਨੇ ਖੇਤਾਂ, ਬਾਗਾਂ ਅਤੇ ਪਹਾੜੀ ਇਲਾਕਿਆਂ ਲਈ ਖਾਸ ਤੌਰ 'ਤੇ ਬਣਾਇਆ ਗਿਆ। EN Steel ਬਲੇਡ, 20-35 HP ਟਰੈਕਟਰ ਨਾਲ ਅਨੁਕੂਲ।",
          specs: ["ਸ਼ਕਤੀ: 20-35 HP", "ਚੌੜਾਈ: 3-5 ਫੁੱਟ", "ਬਲੇਡ: 16-30 (L-ਟਾਈਪ)", "RPM: 540/720"],
          color: "from-orange-900 to-orange-700",
          image: "https://static.prod-images.emergentagent.com/jobs/e89b0584-7119-4b81-8776-d969682d4e3f/images/db1b02de5fc0f01599b62ff23dfc5039d4eaf40081339965f2d08d144277c38e.png",
        },
      ]
    },
    farmers: {
      badge: "ਪੰਜਾਬ ਕਿਸਾਨਾਂ ਲਈ",
      title: "ਫੈਕਟਰੀ ਤੋਂ ਸਿੱਧਾ", title2: "ਤੁਹਾਡੇ ਖੇਤ ਤੱਕ",
      subtitle: "ਕੋਈ ਵਿਚੋਲਾ ਨਹੀਂ। ਅਸਲ ਬੱਚਤ। ਅਸਲ ਭਰੋਸਾ।",
      description: "ਪੰਜਾਬ ਵਿੱਚ ਸਾਡਾ ਨਿਰਮਾਣ ਹੋਣ ਕਾਰਨ, ਅਸੀਂ ਸਥਾਨਕ ਕਿਸਾਨਾਂ ਨੂੰ ਸਿੱਧੀਆਂ ਕੀਮਤਾਂ ਦਿੰਦੇ ਹਾਂ।",
      benefits: [
        "ਫੈਕਟਰੀ ਡਾਇਰੈਕਟ ਕੀਮਤ — ਕੋਈ ਡੀਲਰ ਮਾਰਕਅੱਪ ਨਹੀਂ",
        "ਖਰੀਦਣ ਤੋਂ ਪਹਿਲਾਂ ਸਾਈਟ 'ਤੇ ਡੈਮੋ",
        "ਤੁਹਾਡੇ ਪਿੰਡ ਵਿੱਚ ਆਫਟਰ-ਸੇਲਜ਼ ਸਰਵਿਸ",
      ],
      cta: "ਸਿੱਧੀ ਕੀਮਤ ਲਈ ਪੁੱਛੋ",
    },
    dealers: {
      badge: "ਪੈਨ ਇੰਡੀਆ ਡੀਲਰ ਪ੍ਰੋਗਰਾਮ",
      title: "ਸਭ ਤੋਂ ਵਧੀਆ ਨਾਲ ਭਾਈਵਾਲੀ।", title2: "ਮਿਲ ਕੇ ਵਧੋ।",
      subtitle: "ਪੂਰੇ ਭਾਰਤ ਵਿੱਚ ਸਾਡੇ ਵਧਦੇ ਡੀਲਰ ਨੈੱਟਵਰਕ ਨਾਲ ਜੁੜੋ।",
      description: "ਸ਼੍ਰੀ ਰਾਮ ਐਗਰੋ ਇੰਡਸਟਰੀਜ਼ ਦੇ ਅਧਿਕਾਰਤ ਡੀਲਰ ਬਣੋ ਅਤੇ ਵਧਦੇ ਖੇਤੀ ਮਸ਼ੀਨਰੀ ਬਾਜ਼ਾਰ ਵਿੱਚ ਆਪਣੀ ਜਗ੍ਹਾ ਬਣਾਓ।",
      benefits: [
        "ਐਕਸਕਲੂਸਿਵ ਟੈਰੀਟਰੀ ਅਧਿਕਾਰ",
        "ਉੱਚ ਮੁਨਾਫਾ ਮਾਰਜਿਨ",
        "ਮਾਰਕੀਟਿੰਗ ਅਤੇ ਪ੍ਰਮੋਸ਼ਨਲ ਸਹਾਇਤਾ",
        "ਤੁਹਾਡੀ ਟੀਮ ਲਈ ਤਕਨੀਕੀ ਸਿਖਲਾਈ",
        "ਤੇਜ਼ ਡਿਲੀਵਰੀ ਅਤੇ ਸਟਾਕ ਸਪੋਰਟ",
        "ਪੂਰੇ ਭਾਰਤ ਵਿੱਚ ਮਜ਼ਬੂਤ ਬ੍ਰਾਂਡ ਪਛਾਣ",
      ],
      cta: "ਡੀਲਰਸ਼ਿਪ ਲਈ ਅਰਜ਼ੀ ਦਿਓ",
    },
    whyUs: {
      badge: "ਸਾਨੂੰ ਕਿਉਂ ਚੁਣੋ",
      title: "ਸ਼੍ਰੀ ਰਾਮ ਐਗਰੋ ਦਾ ਫਰਕ",
      items: [
        { icon: "Award", title: "ਸਾਬਤ ਗੁਣਵੱਤਾ", desc: "ਹਰ ਮਸ਼ੀਨ ਫੈਕਟਰੀ ਤੋਂ ਨਿਕਲਣ ਤੋਂ ਪਹਿਲਾਂ ਸਖ਼ਤ ਟੈਸਟਿੰਗ।" },
        { icon: "Users", title: "ਕਿਸਾਨ ਪਹਿਲਾਂ", desc: "ਉਤਪਾਦ ਭਾਰਤੀ ਖੇਤੀ ਸਮਝਣ ਵਾਲੇ ਇੰਜੀਨੀਅਰਾਂ ਦੁਆਰਾ ਡਿਜ਼ਾਈਨ।" },
        { icon: "Wrench", title: "ਆਫਟਰ-ਸੇਲਜ਼ ਸੇਵਾ", desc: "ਪੰਜਾਬ ਭਰ ਵਿੱਚ ਡੈਡੀਕੇਟਡ ਸਰਵਿਸ ਨੈੱਟਵਰਕ।" },
        { icon: "TrendingUp", title: "ਕਿਸਾਨਾਂ ਦਾ ਭਰੋਸਾ", desc: "ਲਗਾਤਾਰ ਵਧੀਆ ਗੁਣਵੱਤਾ ਨਾਲ ਹਜ਼ਾਰਾਂ ਕਿਸਾਨਾਂ ਅਤੇ ਡੀਲਰਾਂ ਦਾ ਭਰੋਸਾ ਕਮਾਇਆ।" },
        { icon: "Shield", title: "ਵਾਰੰਟੀ ਨਾਲ", desc: "ਸਾਰੇ ਉਤਪਾਦਾਂ 'ਤੇ ਨਿਰਮਾਤਾ ਵਾਰੰਟੀ।" },
        { icon: "MapPin", title: "ਭਾਰਤ ਵਿੱਚ ਬਣਿਆ", desc: "ਪੰਜਾਬ ਵਿੱਚ ਮਾਣ ਨਾਲ ਬਣਿਆ।" },
      ]
    },
    testimonials: {
      badge: "ਉਹ ਕੀ ਕਹਿੰਦੇ ਹਨ",
      title: "ਭਾਰਤ ਭਰ ਦੇ ਕਿਸਾਨਾਂ ਅਤੇ ਡੀਲਰਾਂ ਦਾ ਭਰੋਸਾ",
      items: [
        { name: "ਗੁਰਪ੍ਰੀਤ ਸਿੰਘ", location: "ਲੁਧਿਆਣਾ, ਪੰਜਾਬ", role: "ਕਿਸਾਨ", quote: "5 ਸੀਜ਼ਨਾਂ ਤੋਂ ਉਨ੍ਹਾਂ ਦਾ ਰੋਟਾਵੇਟਰ ਵਰਤ ਰਿਹਾ ਹਾਂ। 12 ਏਕੜ ਲਈ ਸਭ ਤੋਂ ਵਧੀਆ ਨਿਵੇਸ਼!" },
        { name: "ਬਲਵਿੰਦਰ ਕੌਰ", location: "ਅੰਮ੍ਰਿਤਸਰ, ਪੰਜਾਬ", role: "ਕਿਸਾਨ", quote: "ਸ਼੍ਰੀ ਰਾਮ ਦੇ ਡਿਸਕ ਹੈਰੋ ਨਾਲ ਸਾਡੇ 20 ਏਕੜ ਦੇ ਖੇਤ ਰਿਕਾਰਡ ਸਮੇਂ ਵਿੱਚ ਤਿਆਰ ਹੋ ਗਏ। ਮਜ਼ਬੂਤ ਬਣਾਵਟ, ਕੜੀ ਮਿੱਟੀ ਵਿੱਚ ਵੀ ਕੋਈ ਮੁਸ਼ਕਲ ਨਹੀਂ। ਸ਼ਾਨਦਾਰ ਮਸ਼ੀਨ!" },
        { name: "ਰਾਜੇਸ਼ ਵਰਮਾ", location: "ਕਰਨਾਲ, ਹਰਿਆਣਾ", role: "ਡੀਲਰ", quote: "ਵਧੀਆ ਮਾਰਜਿਨ, ਸਮੇਂ ਸਿਰ ਡਿਲੀਵਰੀ। ਉਨ੍ਹਾਂ ਦਾ ਡੀਲਰ ਬਣਨਾ ਮੇਰਾ ਸਭ ਤੋਂ ਵਧੀਆ ਫੈਸਲਾ!" },
      ]
    },
    ctaBanner: {
      title: "ਆਪਣੇ ਖੇਤ ਨੂੰ ਬਦਲਣ ਲਈ ਤਿਆਰ ਹੋ?",
      subtitle: "ਅੱਜ ਸਾਡੇ ਖੇਤੀ ਮਾਹਰਾਂ ਨਾਲ ਗੱਲ ਕਰੋ।",
      btnFarmer: "ਕਿਸਾਨ ਵਜੋਂ ਪੁੱਛੋ", btnDealer: "ਡੀਲਰ ਵਜੋਂ ਪੁੱਛੋ",
    },
    about: {
      badge: "ਸਾਡੇ ਬਾਰੇ",
      title: "ਪੰਜਾਬ ਵਿੱਚ ਬਣਿਆ,", title2: "ਪੂਰੇ ਭਾਰਤ ਵਿੱਚ ਭਰੋਸੇਮੰਦ",
      description: "ਸ਼੍ਰੀ ਰਾਮ ਐਗਰੋ ਇੰਡਸਟਰੀਜ਼ ਦੀ ਸਥਾਪਨਾ ਇੱਕ ਉਦੇਸ਼ ਨਾਲ ਹੋਈ: ਭਾਰਤੀ ਕਿਸਾਨਾਂ ਨੂੰ ਵਿਸ਼ਵ-ਪੱਧਰੀ, ਕਿਫਾਇਤੀ ਖੇਤੀ ਮਸ਼ੀਨਰੀ ਪ੍ਰਦਾਨ ਕਰਨਾ।",
      mission_title: "ਸਾਡਾ ਮਿਸ਼ਨ",
      mission: "ਸਭ ਤੋਂ ਭਰੋਸੇਮੰਦ ਅਤੇ ਕਿਫਾਇਤੀ ਖੇਤੀ ਮਸ਼ੀਨਰੀ ਬਣਾਉਣਾ ਜੋ ਭਾਰਤੀ ਖੇਤੀ ਨੂੰ ਬਦਲੇ।",
      values: [
        { title: "ਗੁਣਵੱਤਾ ਪਹਿਲਾਂ", desc: "ਹਰ ਮਸ਼ੀਨ ਫੈਕਟਰੀ ਤੋਂ ਨਿਕਲਣ ਤੋਂ ਪਹਿਲਾਂ ਸਖ਼ਤ ਟੈਸਟਿੰਗ।" },
        { title: "ਕਿਸਾਨ ਕੇਂਦਰਿਤ", desc: "ਸਾਰੇ ਉਤਪਾਦ ਭਾਰਤੀ ਕਿਸਾਨ ਦੀਆਂ ਲੋੜਾਂ ਨੂੰ ਧਿਆਨ ਵਿੱਚ ਰੱਖ ਕੇ ਡਿਜ਼ਾਈਨ।" },
        { title: "ਨਵੀਨਤਾ", desc: "ਆਧੁਨਿਕ ਤਕਨੀਕ ਨਾਲ ਉਤਪਾਦਾਂ ਵਿੱਚ ਨਿਰੰਤਰ ਸੁਧਾਰ।" },
        { title: "ਭਰੋਸਾ", desc: "ਸਾਡੀ ਨਿਰੰਤਰ ਗੁਣਵੱਤਾ ਨੇ ਪੂਰੇ ਭਾਰਤ ਵਿੱਚ ਹਜ਼ਾਰਾਂ ਕਿਸਾਨਾਂ ਦਾ ਭਰੋਸਾ ਕਮਾਇਆ ਹੈ।" },
      ],
      journey: [
        { year: "2009", event: "ਪੰਜਾਬ ਵਿੱਚ ਇੱਕ ਛੋਟੀ ਵਰਕਸ਼ਾਪ ਅਤੇ ਵੱਡੇ ਸੁਪਨਿਆਂ ਨਾਲ ਸਥਾਪਨਾ।" },
        { year: "2012", event: "ਪਹਿਲਾ ਰੋਟਾਵੇਟਰ ਮਾਡਲ ਲਾਂਚ, ਪਹਿਲੇ ਸਾਲ 200 ਯੂਨਿਟ।" },
        { year: "2015", event: "ਡਿਸਕ ਹੈਰੋ ਅਤੇ ਮਲਚਰ ਉਤਪਾਦ ਲਾਈਨ ਵਿੱਚ ਵਿਸਥਾਰ।" },
        { year: "2018", event: "ਉੱਤਰੀ ਭਾਰਤ ਵਿੱਚ 100 ਡੀਲਰ ਭਾਈਵਾਲ।" },
        { year: "2021", event: "ਆਧੁਨਿਕ ਖੇਤੀ ਲਈ ਲੇਜ਼ਰ ਲੈਂਡ ਲੈਵਲਰ ਲਾਂਚ।" },
        { year: "2024", event: "ਪੂਰੇ ਭਾਰਤ ਵਿੱਚ ਉਤਪਾਦ ਸ਼੍ਰੇਣੀ ਅਤੇ ਡੀਲਰ ਨੈੱਟਵਰਕ ਦਾ ਵਿਸਥਾਰ।" },
      ],
      teamTitle: "ਨਿਰਮਾਣ ਉੱਤਮਤਾ",
      teamDesc: "ਪੰਜਾਬ ਵਿੱਚ ਸਾਡੀ ਆਧੁਨਿਕ ਨਿਰਮਾਣ ਸੁਵਿਧਾ ਵਿੱਚ ਅਤਿ-ਆਧੁਨਿਕ ਲੇਜ਼ਰ ਕਟਿੰਗ ਤਕਨੀਕ ਵਰਤੀ ਜਾਂਦੀ ਹੈ। 40+ ਕੁਸ਼ਲ ਕਾਰਮੀਕਾਂ ਨਾਲ, ਅਸੀਂ ਮਜ਼ਬੂਤ ਅਤੇ ਭਰੋਸੇਮੰਦ ਖੇਤੀ ਮਸ਼ੀਨਰੀ ਬਣਾਉਂਦੇ ਹਾਂ।",
    },
    dealers_page: {
      hero_title: "ਡੀਲਰ ਬਣੋ", hero_subtitle: "ਭਾਰਤ ਭਰ ਵਿੱਚ ਸਾਡੇ ਵਧਦੇ ਡੀਲਰ ਨੈੱਟਵਰਕ ਨਾਲ ਜੁੜੋ",
      benefits_title: "ਸਾਡੇ ਨਾਲ ਭਾਈਵਾਲੀ ਕਿਉਂ?",
      process_title: "ਡੀਲਰ ਕਿਵੇਂ ਬਣੀਏ",
      process: [
        { step: "01", title: "ਅਰਜ਼ੀ ਦਿਓ", desc: "ਆਪਣੇ ਕਾਰੋਬਾਰ ਦੇ ਵੇਰਵੇ ਨਾਲ ਡੀਲਰ ਅਰਜ਼ੀ ਫਾਰਮ ਭਰੋ।" },
        { step: "02", title: "ਤਸਦੀਕ ਕਾਲ", desc: "ਸਾਡੀ ਟੀਮ 48 ਘੰਟਿਆਂ ਵਿੱਚ ਤੁਹਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੇਗੀ।" },
        { step: "03", title: "ਸਮਝੌਤਾ ਅਤੇ ਸਿਖਲਾਈ", desc: "ਡੀਲਰਸ਼ਿਪ ਸਮਝੌਤੇ 'ਤੇ ਦਸਤਖਤ ਅਤੇ ਉਤਪਾਦ ਸਿਖਲਾਈ।" },
        { step: "04", title: "ਵੇਚਣਾ ਸ਼ੁਰੂ ਕਰੋ!", desc: "ਪਹਿਲਾ ਸਟਾਕ ਪ੍ਰਾਪਤ ਕਰੋ ਅਤੇ ਆਪਣੇ ਖੇਤਰ ਵਿੱਚ ਸੇਵਾ ਸ਼ੁਰੂ ਕਰੋ।" },
      ],
      form_title: "ਡੀਲਰਸ਼ਿਪ ਲਈ ਅਰਜ਼ੀ ਦਿਓ",
      form: {
        name: "ਤੁਹਾਡਾ ਪੂਰਾ ਨਾਮ", business: "ਕਾਰੋਬਾਰ / ਦੁਕਾਨ ਦਾ ਨਾਮ",
        phone: "ਫੋਨ ਨੰਬਰ", email: "ਈਮੇਲ ਪਤਾ",
        state: "ਰਾਜ ਚੁਣੋ", city: "ਤੁਹਾਡਾ ਸ਼ਹਿਰ",
        brands: "ਮੌਜੂਦਾ ਬ੍ਰਾਂਡ (ਵਿਕਲਪਿਕ)", message: "ਆਪਣੇ ਕਾਰੋਬਾਰ ਬਾਰੇ ਦੱਸੋ",
        submit: "ਅਰਜ਼ੀ ਜਮਾਂ ਕਰੋ",
        success: "ਅਰਜ਼ੀ ਜਮਾਂ ਹੋਈ! ਸਾਡੀ ਟੀਮ 48 ਘੰਟਿਆਂ ਵਿੱਚ ਸੰਪਰਕ ਕਰੇਗੀ।",
      }
    },
    contact: {
      title: "ਸੰਪਰਕ ਕਰੋ", subtitle: "ਅਸੀਂ ਮਦਦ ਲਈ ਇੱਥੇ ਹਾਂ। ਕਦੇ ਵੀ ਸੰਪਰਕ ਕਰੋ।",
      form: {
        name: "ਪੂਰਾ ਨਾਮ", phone: "ਫੋਨ ਨੰਬਰ", email: "ਈਮੇਲ (ਵਿਕਲਪਿਕ)",
        product: "ਉਤਪਾਦ ਦੀ ਰੁਚੀ", state: "ਤੁਹਾਡਾ ਰਾਜ", message: "ਤੁਹਾਡਾ ਸੁਨੇਹਾ",
        submit: "ਪੁੱਛਗਿੱਛ ਭੇਜੋ",
        success: "ਧੰਨਵਾਦ! ਅਸੀਂ 24 ਘੰਟਿਆਂ ਵਿੱਚ ਸੰਪਰਕ ਕਰਾਂਗੇ।",
      },
      info: {
        address: "ਫੇਜ਼-7, ਫੋਕਲ ਪੁਆਇੰਟ, ਅਸ਼ੋਕਾ ਕਾਂਡਾ ਦੇ ਨੇੜੇ, ਵਿਲੇਜ-ਗੋਬਿੰਦਗੜ੍ਹ, ਲੁਧਿਆਣਾ, ਪੰਜਾਬ — 141010",
        phone: "+91 76968 99983", email: "shreeramagroindustries2024@gmail.com",
        hours: "ਸੋਮ–ਸ਼ਨੀ: ਸਵੇਰੇ 9 ਵਜੇ – ਸ਼ਾਮ 6 ਵਜੇ",
        whatsapp: "WhatsApp 'ਤੇ ਚੈਟ ਕਰੋ",
      }
    },
    gallery: {
      badge: "ਗੈਲਰੀ", title: "ਸਾਡੀਆਂ ਮਸ਼ੀਨਾਂ ਕੰਮ ਵਿੱਚ",
      subtitle: "ਦੇਖੋ ਕਿਵੇਂ ਸ਼੍ਰੀ ਰਾਮ ਐਗਰੋ ਮਸ਼ੀਨਰੀ ਪੂਰੇ ਭਾਰਤ ਦੇ ਖੇਤਾਂ ਨੂੰ ਬਦਲ ਰਹੀ ਹੈ।",
      photos: "ਫੋਟੋਆਂ", videos: "ਵੀਡੀਓ",
    },
    footer: {
      tagline: "ਆਧੁਨਿਕ ਯੰਤਰ, ਖੁਸ਼ਹਾਲ ਕਿਸਾਨ | आधुनिक यंत्र, समृद्ध किसान",
      about: "ਪੰਜਾਬ ਦਾ ਭਰੋਸੇਮੰਦ ਖੇਤੀ ਮਸ਼ੀਨਰੀ ਨਿਰਮਾਤਾ। ਪੂਰੇ ਭਾਰਤ ਦੇ ਕਿਸਾਨਾਂ ਅਤੇ ਡੀਲਰਾਂ ਦੀ ਸੇਵਾ ਵਿੱਚ।",
      quickLinks: "ਤੇਜ਼ ਲਿੰਕ", products: "ਉਤਪਾਦ", contactInfo: "ਸੰਪਰਕ ਜਾਣਕਾਰੀ",
      copyright: "© 2024 ਸ਼੍ਰੀ ਰਾਮ ਐਗਰੋ ਇੰਡਸਟਰੀਜ਼। ਸਾਰੇ ਅਧਿਕਾਰ ਰਾਖਵੇਂ।",
      links: { products: "ਸਾਡੇ ਉਤਪਾਦ", about: "ਸਾਡੇ ਬਾਰੇ", dealers: "ਡੀਲਰ ਪ੍ਰੋਗਰਾਮ", contact: "ਸੰਪਰਕ ਕਰੋ", gallery: "ਗੈਲਰੀ" }
    }
  }
};

export default translations;
